var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgH1Laptop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.64 53A3.999 3.999 0 0062 50V22a4 4 0 00-4-4H18a4 4 0 00-4 4v28a4.179 4.179 0 001.35 3H3v4h70v-4H60.64zM58 50H18V22h40v28z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/H1_Laptop.8599bc78.svg";
export { SvgH1Laptop as ReactComponent };